import React, { createContext, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { lookUp } from '../api/LookUpAPI';

const TelemedicineCategoryContext = createContext();

export const useTelemedicineCategoryContext = () => {
    const context = useContext(TelemedicineCategoryContext);
    if (!context) {
        throw new Error("usetelemedicineCategoryContext must be used within a telemedicineCategoryProvider");
    }
    return context;
}

export const TelemedicineCategoryProvider = ({ children, value }) => {
    const [telemedicineCategories, setTelemedicineCategories] = useState([])

    const getTelemedicineCategoryNameById = useCallback(id => {
        return telemedicineCategories.find(category => category._id === id)?.name
    }, [telemedicineCategories])

    const getTelemedicineCategoryIdByName = useCallback(name => {
        return telemedicineCategories.find(category => category.name === name)?._id
    }, [telemedicineCategories])

    useEffect(() => {
        lookUp('tele-medicine-category')
            .then(({ data }) => setTelemedicineCategories(data.payload))
            .catch(e => console.error(e))
    }, [])

    const contextValue = useMemo(() => ({
        telemedicineCategories,
        getTelemedicineCategoryNameById,
        getTelemedicineCategoryIdByName
    }), [telemedicineCategories, getTelemedicineCategoryNameById, getTelemedicineCategoryIdByName])

    return (
        <TelemedicineCategoryContext.Provider value={contextValue}>
            {children}
        </TelemedicineCategoryContext.Provider>
    );
};
